import { useLanguage } from './LanguageContext';
import outsideBackground from '../images/datson-tattoo-outside.jpeg';
// import insideBackground from '../images/datson-tattoo-inside.jpeg'
import landingImg from '../images/datson-landing.jpeg';
import hinh1 from '../images/hinh1.jpg';
import hinh2 from '../images/hinh2.jpg';
import hinh3 from '../images/hinh3.jpg';
import hinh4 from '../images/hinh4.jpg';
import hinh5 from '../images/hinh5.jpg';
import hinh6 from '../images/hinh6.jpg';
import hinh7 from '../images/hinh7.jpg';
import hinh8 from '../images/hinh8.jpg';
import hinh9 from '../images/hinh9.jpg';
import hinh10 from '../images/hinh10.jpg';

function Landing() {
	const { language } = useLanguage(); // Get the current language
	return (
		<>
			{language === 'en' ? (
				<div className='flex flex-col space-y-5'>
					<section
						data-aos='fade-up'
						className='bg-cover bg-center bg-no-repeat w-full min-h-screen animate-fadeIn'
						style={{ backgroundImage: `url(${landingImg})` }}></section>
					<section className='dark:bg-white dark:text-black'>
						<div
							data-aos='fade-up'
							className='container flex flex-col justify-center p-6 mx-auto sm:py-12 lg:py-24 lg:flex-row lg:justify-between'>
							<div className='flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128 lg:w-1/2  bg-no-repeat'>
								<img
									alt='datson tattoo logo'
									className='object-contain h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128 w-full rounded-lg'
									src={outsideBackground}
								/>
							</div>
							<div className='flex flex-col justify-center p-6 text-center rounded-sm lg:max-w-md xl:max-w-lg lg:text-left'>
								<h1 className='text-5xl font-bold leadi sm:text-6xl didot'>
									Datson Tattoo
								</h1>
								<p className='mt-6 mb-8 text-lg sm:mb-12 avenir'>
									" Honoring the asthetics of the human body and soul through
									tattoo "
								</p>
								<div className='flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start'>
									<a
										rel='noopener noreferrer'
										href='/booking'
										className='avenir px-8 py-3 text-lg font-semibold rounded bg-darkBrown text-white'>
										Booking
									</a>
									<a
										rel='noopener noreferrer'
										href='/studio'
										className='avenir px-10 py-3 text-lg font-semibold  rounded bg-darkBrown text-white'>
										Studio
									</a>
								</div>
							</div>
						</div>
					</section>

					<div class='space-y-2 text-center'>
						<h2 class='text-3xl font-bold'>My Work</h2>
						<p class='font-serif text-sm dark:text-gray-400'>
							Each tattoo has its own meaning
						</p>
					</div>
					<section data-aos='fade-up' class='py-6  dark:text-gray-50'>
						<div class='container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-4'>
							<img
								src={hinh10}
								alt=''
								class='w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-3 md:row-start-1 dark:bg-gray-500 aspect-square'
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh9}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh2}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh3}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh4}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh5}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh6}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh7}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh8}
							/>
							<img
								src={hinh1}
								alt=''
								class='w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-1 md:row-start-3 dark:bg-gray-500 aspect-square'
							/>
						</div>
					</section>
					{/* <section>
    <h2 className="mb-12 text-4xl font-bold text-center sm:text-5xl">Datson Studio</h2>

        <div className="container flex p-2 mx-auto flex-wrap space-x-6 space-y-8 bg-lightBrown rounded">
            <div className="w-full sm:w-2/4 flex flex-col justify-center space-y-4" id="mystudio">
                <p className="text-2xl mt-1 text-black text-center avenir">" Datson Studio là một không gian trải nghiệm nghệ thuật xăm hình đương đại, cùng những thiết kế hình xăm được cá nhân hoá thể hiện tính thẩm mỹ vượt thời gian. </p>
                <p className="text-2xl mt-1 text-black text-center avenir">Bên cạnh đó Studio còn đem đến các hình thức giáo dục, kết nối, hợp tác nghệ thuật.
                Trải nghiệm hình xăm riêng tư cùng nghệ sĩ xăm hình của riêng bạn tại studio của chúng tôi "
                </p>
            </div>
            <div className=" w-2/5">
                <img className="rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" alt="inside shop" src={insideBackground}/>
            </div>
           
            
            
        </div>
    </section> */}

					<section class='text-black avenir bg-lightBrown'>
						<div class='container flex flex-col justify-center p-4 mx-auto md:p-8'>
							<p class='p-2 text-sm font-medium tracki text-center uppercase'>
								How it works
							</p>
							<h2 class='mb-12 text-4xl font-bold text-center sm:text-5xl'>
								Frequently Asked Questions
							</h2>
							<div class='flex flex-col divide-y sm:px-8 lg:px-12 xl:px-32 dark:divide-gray-700'>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										How much does a tattoo cost?
									</summary>
									<div class='px-4 pb-4'>
										<p>
											Each tattoo will have a different price, and each artist
											will have a different pricing structure. The basic factors
											for pricing a tattoo are:
											<ul>
												<li>* Content of the idea</li>
												<li>* Size</li>
												<li>* Position</li>
												<li>* Color</li>
												<li>* Level of detail, complexity</li>
											</ul>
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										How long does the design process take?
									</summary>
									<div class='px-4 pb-4'>
										<p>
											Depending on the content of the tattoo, the designs will
											take from 1 day to 2 weeks to complete.
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										Can I see in advance or discuss and modify the details in
										the design?
									</summary>
									<div class='px-4 pb-4 space-y-2'>
										<p>
											Yes. You can preview the design after the time agreed upon
											with the artist, and modifications to the design details
											can be made up to 2 times (without additional charge).
											Starting from the 3rd modification, there will be an
											additional fee.
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										How far in advance do I need to make an appointment?
									</summary>
									<div class='px-4 pb-4 space-y-2'>
										<p>
											To facilitate the scheduling of the design and tattooing,
											please make an appointment as soon as you have a tattoo
											idea. The minimum time you need to book an appointment is
											at least 1 day before the tattooing.
										</p>
										<p>
											*Note: The earlier you schedule, the better the quality
											will be for discussing content and drawing the design.
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										How much deposit do I need to pay when booking an
										appointment for design and tattooing?
									</summary>
									<div class='px-4 pb-4 space-y-2'>
										<p>
											The design and tattooing appointment will only be
											confirmed once the deposit procedure is completed. The
											deposit amount will be based on the content of the tattoo,
											and you will receive a deposit notification along with the
											cost during the discussion process.
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										What is the warranty policy?
									</summary>
									<div class='px-4 pb-4 space-y-2'>
										<p>
											We offer a lifetime warranty policy for customers who have
											had tattoos done at Datson Studio. You can schedule a free
											check-up and touch-up of the tattoo (if necessary) within
											3 months from the date of the tattooing.
										</p>
									</div>
								</details>
							</div>
						</div>
					</section>
				</div>
			) : (
				<div className='flex flex-col space-y-5'>
					<section
						data-aos='fade-up'
						className='bg-cover bg-center bg-no-repeat w-full min-h-screen animate-fadeIn'
						style={{ backgroundImage: `url(${landingImg})` }}></section>
					<section data-aos='fade-up' className='dark:bg-white dark:text-black'>
						<div className='container flex flex-col justify-center p-6 mx-auto sm:py-12 lg:py-24 lg:flex-row lg:justify-between'>
							<div className='flex items-center justify-center p-6 mt-8 lg:mt-0 h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128 lg:w-1/2  bg-no-repeat'>
								<img
									alt='datson tattoo logo'
									className='object-contain h-72 sm:h-80 lg:h-96 xl:h-112 2xl:h-128 w-full rounded-lg'
									src={outsideBackground}
								/>
							</div>
							<div className='flex flex-col justify-center p-6 text-center rounded-sm lg:max-w-md xl:max-w-lg lg:text-left'>
								<h1 className='text-5xl font-bold leadi sm:text-6xl didot'>
									Datson Tattoo
								</h1>
								<p className='mt-6 mb-8 text-lg sm:mb-12 avenir'>
									"Tôn vinh vẻ đẹp thẩm mỹ của cơ thể và tâm hồn con người thông
									qua hình xăm."
								</p>
								<div className='flex flex-col space-y-4 sm:items-center sm:justify-center sm:flex-row sm:space-y-0 sm:space-x-4 lg:justify-start'>
									<a
										rel='noopener noreferrer'
										href='/booking'
										className='avenir px-8 py-3 text-lg font-semibold rounded bg-darkBrown text-white'>
										Đặt Hẹn
									</a>
									<a
										rel='noopener noreferrer'
										href='/studio'
										className='avenir px-10 py-3 text-lg font-semibold  rounded bg-darkBrown text-white'>
										Studio
									</a>
								</div>
							</div>
						</div>
					</section>

					<div class='space-y-2 text-center'>
						<h2 class='text-3xl font-bold'>Nghệ Thuật Mà Tôi Tạo Ra</h2>
						<p class='font-serif text-sm dark:text-gray-400'>
							Mỗi hình xăm đều ẩn chứa một ý nghĩa đặc biệt
						</p>
					</div>
					<section data-aos='fade-up' class='py-6  dark:text-gray-50'>
						<div class='container grid grid-cols-2 gap-4 p-4 mx-auto md:grid-cols-4'>
							<img
								src={hinh10}
								alt=''
								class='w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-3 md:row-start-1 dark:bg-gray-500 aspect-square'
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh9}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh2}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh3}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh4}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh5}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh6}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh7}
							/>
							<img
								alt=''
								class='w-full h-full rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square object-cover'
								src={hinh8}
							/>
							<img
								src={hinh1}
								alt=''
								class='w-full h-full col-span-2 row-span-2 rounded shadow-sm min-h-96 md:col-start-1 md:row-start-3 dark:bg-gray-500 aspect-square'
							/>
						</div>
					</section>
					{/* <section>
    <h2 className="mb-12 text-4xl font-bold text-center sm:text-5xl">Datson Studio</h2>

        <div className="container flex p-2 mx-auto flex-wrap space-x-6 space-y-8 bg-lightBrown rounded">
            <div className="w-full sm:w-2/4 flex flex-col justify-center space-y-4" id="mystudio">
                <p className="text-2xl mt-1 text-black text-center avenir">" Datson Studio là một không gian trải nghiệm nghệ thuật xăm hình đương đại, cùng những thiết kế hình xăm được cá nhân hoá thể hiện tính thẩm mỹ vượt thời gian. </p>
                <p className="text-2xl mt-1 text-black text-center avenir">Bên cạnh đó Studio còn đem đến các hình thức giáo dục, kết nối, hợp tác nghệ thuật.
                Trải nghiệm hình xăm riêng tư cùng nghệ sĩ xăm hình của riêng bạn tại studio của chúng tôi "
                </p>
            </div>
            <div className=" w-2/5">
                <img className="rounded shadow-sm min-h-48 dark:bg-gray-500 aspect-square" alt="inside shop" src={insideBackground}/>
            </div>
           
            
            
        </div>
    </section> */}

					<section class='text-black avenir bg-lightBrown'>
						<div class='container flex flex-col justify-center p-4 mx-auto md:p-8'>
							<p class='p-2 text-sm font-medium tracki text-center uppercase'>
								Cách thức hoạt động
							</p>
							<h2 class='mb-12 text-4xl font-bold text-center sm:text-5xl'>
								Những Câu Hỏi Thường Gặp
							</h2>
							<div class='flex flex-col divide-y sm:px-8 lg:px-12 xl:px-32 dark:divide-gray-700'>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										Mức giá của một hình xăm là bao nhiêu?
									</summary>
									<div class='px-4 pb-4'>
										<p>
											Mỗi hình xăm sẽ có một mức giá khác nhau và mỗi artist sẽ
											có một mức định giá khác nhau. Các yếu tố cơ bản để định
											giá một hình xăm:
											<ul>
												<li>* Nội dung ý tưởng</li>
												<li>* Kích thước</li>
												<li>* Vị trí</li>
												<li>* Màu sắc</li>
												<li>* Độ chi tiết, mức độ phức tạp</li>
											</ul>
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										Quá trình thiết kế được thực hiện trong bao lâu?
									</summary>
									<div class='px-4 pb-4'>
										<p>
											Tuỳ thuộc vào nội dung của hình xăm, các thiết kế sẽ cần
											thời gian từ 1 ngày đến 2 tuần để thực hiện.
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										Tôi có được xem trước hoặc trao đổi, chỉnh sửa lại các chi
										tiết trong thiết kế không?
									</summary>
									<div class='px-4 pb-4 space-y-2'>
										<p>
											Có. Bạn có thể xem trước thiết kế sau thời gian đã thống
											nhất với Artist, và việc chỉnh sửa lại các chi tiết trong
											thiết kế được thực hiện tối đa 2 lần (không phụ phí), từ
											lần chỉnh sửa thứ 3 sẽ có phụ phí đi kèm.
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										Tôi cần đặt lịch trước bao lâu?
									</summary>
									<div class='px-4 pb-4 space-y-2'>
										<p>
											Để thuận tiện cho việc sắp xếp lịch thiết kế và xăm hình,
											bạn hãy đặt lịch sớm nhất ngay khi bạn có ý tưởng đi xăm.
											Thời gian tối thiểu bạn cần đặt lịch là trước 1 ngày đi
											xăm.
										</p>
										<p>
											*Lưu ý: thời gian đặt lịch càng sớm sẽ đảm bảo được chất
											lượng tốt nhất cho việc trao đổi nội dung và vẽ thiết kế.
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										Tôi cần phải đặt cọc bao nhiêu khi đặt lịch thiết kế và xăm
										hình?
									</summary>
									<div class='px-4 pb-4 space-y-2'>
										<p>
											Lịch thiết kế và xăm hình chỉ được xác nhận khi đã hoàn
											tất thủ tục đặt cọc. Chi phí đặt cọc sẽ dựa theo nội dung
											xăm hình phù hợp, bạn sẽ nhận được thông báo đặt cọc và
											mức chi phí trong quá trình trao đổi làm việc.
										</p>
									</div>
								</details>
								<details>
									<summary class='py-2 outline-none cursor-pointer focus:underline'>
										Chính sách bảo hành như thế nào?
									</summary>
									<div class='px-4 pb-4 space-y-2'>
										<p>
											Chúng tôi áp dụng chính sách bảo hành trọn đời dành cho
											khách hàng đã thực hiện hình xăm tại Datson Studio. Lên
											lịch kiểm tra và dặm lại hình xăm miễn phí (trường hợp cần
											thiết) trong thời gian 3 tháng tính từ ngày thực hiện hình
											xăm.
										</p>
									</div>
								</details>
							</div>
						</div>
					</section>
				</div>
			)}
		</>
	);
}

export default Landing;
